import React, { Component } from "react";
import { Form } from "react-bootstrap";
import CustomButton from "./CustomButton";
import Tick from "../assets/tick.svg";
import moment from "moment-timezone";

export default class MyOrderItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      time: "",
    };
  }

  componentDidMount() {
    var zone_name = moment.tz.guess();
    let newdatetime = moment
      .tz(this.props.items[0].createdAt, zone_name)
      .format("HH:mm")
      .toString();

    this.setState({ time: newdatetime });
  }

  onCompleteOrder() {
    this.props.completeOrder(this.props.items[0].orderId);
  }

  render() {
    return (
      <div
        className="myOrderItem"
        style={{
          border: this.props.isDeleted
            ? "1px solid var(--red1)"
            : "1px solid var(--brown1)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "right",
            }}
          >
            <div>
              {!this.props.isDeleted && !!this.props.isEdited ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <div>{this.props.stationName}</div>{" "}
                  <div style={{ color: "var(--brown1)", fontSize: "12px" }}>
                    (
                    {this.props.OSEdited
                      ? "ویرایش شده - جابه‌جایی ایستگاه"
                      : "ویرایش شده"}
                    )
                  </div>
                </div>
              ) : null}

              {!this.props.isDeleted &&
              !this.props.isEdited &&
              this.props.OSEdited ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <div>{this.props.stationName}</div>{" "}
                  <div style={{ color: "var(--brown1)", fontSize: "12px" }}>
                    (جابه‌جایی ایستگاه)
                  </div>
                </div>
              ) : null}

              {this.props.isDeleted ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <div>{this.props.stationName}</div>{" "}
                  <div style={{ color: "var(--red1)", fontSize: "12px" }}>
                    (ابطال شده)
                  </div>
                </div>
              ) : null}
              {!this.props.isDeleted &&
                !this.props.isEdited &&
                !this.props.OSEdited && <div>{this.props.stationName}</div>}
            </div>
            <div
              style={{
                marginTop: "5px",
                fontSize: "12px",
                color: "var(--gray3)",
              }}
            >
              🕥 {this.state.time}
            </div>
          </div>
          <div
            style={{
              border: "1px solid var(--brown1)",
              padding: "7px 12px",
              borderRadius: "8px",
            }}
          >
            {this.props.orderId}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "var(--brown1)",
            minHeight: "2px",
            marginTop: "5px",
          }}
        />

        {this.props.items.map((item, i) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                flex: "1",
                cursor: !item.isDeleted ? "pointer" : "default",
                userSelect: "none",
              }}
              key={i}
              onClick={() => {
                if (item.selected && !item.isDeleted)
                  this.props.uncheckItem(item.id);
                else if (!item.isDeleted) this.props.checkItem(item.id);
              }}
            >
              <div
                style={{
                  width: "100%",
                  padding: "15px 5px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                <Form.Check
                  type="checkbox"
                  checked={item.selected}
                  readOnly
                  // disabled={item.selected}
                  disabled={item.isDeleted}
                ></Form.Check>
                <div
                  style={{
                    marginRight: "10px",
                    textDecoration:
                      item.selected || item.isDeleted ? "line-through" : "none",
                    fontStyle:
                      item.selected || item.isDeleted ? "italic" : "normal",
                    color: item.selected
                      ? "var(--gray4)"
                      : item.isDeleted
                      ? "var(--red1)"
                      : "var(--black1)",
                    flex: "1",
                    textAlign: "right",
                  }}
                >
                  {item.foodName}
                </div>

                <div
                  style={{
                    marginRight: "10px",
                    textDecoration: item.selected ? "line-through" : "none",
                    fontStyle: item.selected ? "italic" : "normal",
                    color: item.selected ? "var(--gray4)" : "var(--black1)",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.lastQuantity && !item.isDeleted ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "5px",
                      }}
                    >
                      <div style={{ color: "var(--gray3)" }}>
                        {item.lastQuantity}
                      </div>
                      ⬅
                      <div>
                        <div>{item.quantity}</div>
                      </div>
                    </div>
                  ) : (
                    item.quantity
                  )}
                </div>
              </div>

              {i < this.props.items.length - 1 && (
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "var(--gray4)",
                    minHeight: "1px",
                  }}
                />
              )}
            </div>
          );
        })}

        {this.props.otherItems && this.props.otherItems.length > 0 && (
          <div
            style={{
              width: "100%",
              backgroundColor: "var(--black1)",
              minHeight: "2px",
            }}
          />
        )}

        {this.props.otherItems &&
          this.props.otherItems.map((item, i) => {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  flex: "1",
                  cursor: "pointer",
                  userSelect: "none",
                }}
                key={i}
              >
                <div
                  style={{
                    width: "100%",
                    padding: "15px 5px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    fontSize: "14px",
                  }}
                >
                  <div
                    style={{
                      marginRight: "10px",
                      textDecoration: item.selected ? "line-through" : "none",
                      fontStyle: item.selected ? "italic" : "normal",
                      // color: item.selected ? "var(--gray4)" : "var(--black1)",
                      color: "var(--gray4)",
                      flex: "1",
                      textAlign: "right",
                    }}
                  >
                    {item.foodName}
                  </div>

                  <div
                    style={{
                      marginRight: "10px",
                      textDecoration: item.selected ? "line-through" : "none",
                      fontStyle: item.selected ? "italic" : "normal",
                      color: "var(--gray4)",
                    }}
                  >
                    {item.quantity}
                  </div>
                </div>

                {this.props.otherItems &&
                  i < this.props.otherItems.length - 1 && (
                    <div
                      style={{
                        width: "100%",
                        backgroundColor: "var(--gray4)",
                        minHeight: "1px",
                      }}
                    />
                  )}
              </div>
            );
          })}

        {this.props.descr && (
          <div
            style={{
              width: "100%",
              borderRadius: "10px",
              backgroundColor: "var(--gray4)",
              padding: "10px 5px",
              fontSize: "12px",
              textAlign: "start",
            }}
          >
            {this.props.descrEdited ? "*** " : null}
            {this.props.descr}
          </div>
        )}
        {!this.props.isDeleted && (
          <div style={{ marginTop: "20px", width: "100%" }}>
            <CustomButton
              title="اتمام آماده سازی"
              //   loading={this.state.writingProgress}
              imgHeight={20}
              imgWidth={25}
              minHeight="35px"
              img={Tick}
              onClick={this.onCompleteOrder.bind(this)}
            />
          </div>
        )}
      </div>
    );
  }
}
